import { Scene } from "../gameData";
import { expectGameContext, expectScene } from ".";

export function expectCurrentScene(): Scene {
    const ctx = expectGameContext();
    return expectScene(ctx.gameState.currentSceneId);
}
